<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M14.6663 12.6667C14.6663 13.0203 14.5259 13.3594 14.2758 13.6095C14.0258 13.8595 13.6866 14 13.333 14H2.66634C2.31272 14 1.97358 13.8595 1.72353 13.6095C1.47348 13.3594 1.33301 13.0203 1.33301 12.6667V3.33333C1.33301 2.97971 1.47348 2.64057 1.72353 2.39052C1.97358 2.14048 2.31272 2 2.66634 2H5.99967L7.33301 4H13.333C13.6866 4 14.0258 4.14048 14.2758 4.39052C14.5259 4.64057 14.6663 4.97971 14.6663 5.33333V12.6667Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
